import { Link } from "react-router-dom";

const QUICK_LINKS = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/series" },
  { label: "综艺", to: "/category/variety" },
  { label: "影视资讯", to: "/news" },
  { label: "关于我们", to: "/about" },
];

const FRIEND_LINKS = ["影视观察", "票房日报", "片场直击", "综艺前沿", "电影手册"];

const SOCIALS = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-bilibili-fill", label: "哔哩哔哩" },
  { icon: "ri-youtube-fill", label: "YouTube" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-primary-950 text-background-100">
      <div className="px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          {/* 品牌简介 */}
          <div className="md:col-span-5">
            <Link to="/" className="mb-4 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-play-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-extrabold tracking-tight text-background-50">
                WWW.<span className="text-accent-400">17C</span>
              </span>
            </Link>
            <p className="max-w-md text-sm leading-relaxed text-background-300">
              WWW.17C 是一个综合影视内容平台，汇集电影、电视剧、综艺等丰富影视资源与最新行业资讯，
              帮助观众快速发现感兴趣的作品，畅享舒适的浏览与阅读体验。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {SOCIALS.map((s) => (
                <span
                  key={s.label}
                  title={`${s.label}（演示）`}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-primary-900 text-background-200 transition-colors hover:bg-accent-500 hover:text-primary-950"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>

          {/* 快捷导航 */}
          <div className="md:col-span-3">
            <h4 className="mb-4 font-heading text-sm font-semibold tracking-wide text-background-50">
              快捷导航
            </h4>
            <ul className="grid grid-cols-2 gap-y-2.5 md:grid-cols-1">
              {QUICK_LINKS.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-300 transition-colors hover:text-accent-400"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 联系与友链 */}
          <div className="md:col-span-4">
            <h4 className="mb-4 font-heading text-sm font-semibold tracking-wide text-background-50">
              联系我们
            </h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                <span>contact@www17c.example</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-accent-400"></i>
                <span>合作与反馈：service@www17c.example</span>
              </li>
            </ul>
            <h4 className="mb-3 mt-6 font-heading text-sm font-semibold tracking-wide text-background-50">
              友情链接
            </h4>
            <div className="flex flex-wrap gap-2">
              {FRIEND_LINKS.map((name) => (
                <span
                  key={name}
                  className="cursor-pointer rounded-full bg-primary-900 px-3 py-1 text-xs text-background-200 transition-colors hover:bg-primary-800"
                >
                  {name}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-primary-900 pt-6 text-xs text-background-400 sm:flex-row sm:items-center">
          <p>© 2026 WWW.17C 影视平台 · 本站内容仅供浏览与学习演示，不提供在线播放与下载服务。</p>
          <p className="whitespace-nowrap">Made for movie lovers</p>
        </div>
      </div>
    </footer>
  );
}